import React from "react";
// Zustand
import { useStore } from "../../zustand";
// Icons
import { ReactComponent as Arrow } from "../../assets/icons/left_arrow.svg";
// Styles
import { makeStyles } from '@material-ui/core/styles';
import { billboardStyles } from "../../assets/jss/billboardStyles";
const useStyles = makeStyles(billboardStyles);

const BillboardsMobileDropdown = (props) => {
    const { active_board } = useStore(state => state.scene_controls);
    const { spec } = props;
    // const dynamic_text_settings = useStore.getState().dynamic_text_settings;
    const { dynamic_text_settings } = useStore.getState().store_settings;
    const { vList } = useStore.getState().variants_payload;
    const variant_id = useStore.getState().variant_id;
    const { h1, p } = vList[variant_id].billboard_list[active_board].info;
    const billboard_info_mobile = React.useRef(0)
    const classes = useStyles(dynamic_text_settings);
    
    const _handleInfoClose = () => {
        let billboardInfo = billboard_info_mobile.current;
        if (billboardInfo.classList.contains('collapsed')) {
            billboardInfo.classList.remove('collapsed');
        } else {
            billboardInfo.classList.add('collapsed');
        }
    }

    return (
        <div className={classes.billboard_info_wrapper}>
            <div ref={billboard_info_mobile} className={classes.billboard_info_mobile}>
                <div className={classes.title_container_mobile}>
                    <h6 className={classes.title}>{h1.text}</h6>
                    <Arrow className={classes.billboard_info_close} onClick={() => _handleInfoClose()}/>
                </div>
                <div className={classes.billboard_body}>
                    <p className={classes.p1}>{p.text}</p>
                    { spec &&
                        <a href={spec} target="_blank" className={classes.specs} rel="noopener noreferrer">View Specs</a>
                    }
                </div>
            </div>
        </div>
    );   
}

export default BillboardsMobileDropdown;